<template>
  <div>
    <div class="promoted-object" v-if="planForm.promotedObject && planForm.promotedObject.promoted_object_id">
      <el-avatar :size="32" :src="planForm.promotedObject.icon"></el-avatar>
      <span :title="planForm.promotedObject.promoted_object_name" class="app-name">
        <span> &ensp;{{ planForm.promotedObject.promoted_object_name }}</span>
        <span :title="planForm.promotedObject.promoted_object_id"> &ensp;{{ planForm.promotedObject.promoted_object_id }}</span>
      </span>
      <el-button type="text" @click="onClear"> &emsp;&emsp;修改</el-button>
    </div>

    <el-select
      v-else
      v-model="planForm.promotedObject"
      filterable
      :filter-method="onPromotedObjectFilter"
      @keyup.native="onAppIdInput"
      @change="onPromotedObjectChange"
      :loading="appIdDataLoading"
      value-key="promoted_object_id"
      style="width: 100%"
      placeholder="请选择应用ID"
    >
      <el-option v-for="item in gameAppIdList" :key="item.promoted_object_id" :label="item.promoted_object_name" :value="item">
        <div class="el-option-slot">
          <span>
            <el-avatar size="small" :src="item.icon"></el-avatar>
          </span>
          <span style="margin-left: 5px">{{ item.promoted_object_name }}</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getPromotedObject, addPromotedObject } from '@/api/tencent.model'
import { PLATFORM, PROMOTED_TYPE, PROMOTED_TYPE_BY_PLATFORM } from '../../model/project-const.js'

let timer = 0
export default {
  props: {
    value: {
      type: Object
    }
  },
  inject: ['projectInstance'],
  data() {
    return {
      gameAppIdList: [],
      appIdDataLoading: false
    }
  },
  watch: {
    /**
     * @description: 账号变化时，重新获取应用id
     * @description: 当批量复制、修改流程，请求到任务数据后，也会触发账号变化
     * @return {*}
     */
    'planForm.accounts'() {
      this.getAppIdByAccount()
    },
    /**
     * @description: 平台变化时，重新获取应用id
     * @return {*}
     */
    'planForm.ch_platform_id'() {
      this.getAppIdByAccount()
    }
  },

  computed: {
    planForm: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      }
    },
    pageStates() {
      return this.projectInstance.pageStates
    }
  },
  methods: {
    /**
     * @description: 输入appId新增游戏
     * @return {*}
     */
    onAppIdInput(e) {
      clearTimeout(timer)
      timer = setTimeout(async () => {
        const id = e.target.value
        const promoted_object_type = PROMOTED_TYPE_BY_PLATFORM[this.planForm.ch_platform_id]
        this.appIdDataLoading = true
        for (const i in this.planForm.accounts) {
          const ad_account_id = this.planForm.accounts[i]

          if (!id || !ad_account_id) break

          await addPromotedObject({
            ad_account_id,
            promoted_object_type,
            promoted_object_id: id
          })
        }

        this.getAppIdByAccount()

        this.appIdDataLoading = false
      }, 1200)
    },

    /**
     * @description: 根据账号和推广目标类型获取应用id
     */
    getAppIdByAccount() {
      const { accounts, ch_platform_id } = this.planForm
      const promoted_object_type = PROMOTED_TYPE_BY_PLATFORM[ch_platform_id]

      const [accountId] = accounts
      if (!accountId) return
      getPromotedObject({
        ad_account_id: Number(accountId),
        promoted_object_type
      })
        .then((data) => {
          const spce = ['', 'app_android_spec', 'app_ios_spec', 'mini_game_wechat_spec'][ch_platform_id]
          if (!spce) return

          // 每个平台的icon path不一样，作统一处理
          this.gameAppIdList = data.map((promote) => {
            return {
              ...promote,
              icon: promote.promoted_object_spec[spce].icon
            }
          })

          // 当批量修改、复制、单条修改流程时，根据项目应用id找到对应应用信息用于显示
          const { isDuplicate, isModify, isUpdate } = this.pageStates
          if (isDuplicate || isModify || isUpdate) {
            const newForm = this.planForm
            const appInfo = this.gameAppIdList.find((app) => app.promoted_object_id === newForm.promotedObject.promoted_object_id)
            if (appInfo) {
              newForm.promotedObject = appInfo
              this.planForm = newForm
            }
          }
        })
        .catch((e) => {
          console.log(`获取应用ID列表失败 output: ${e.message}`)
        })
    },
    onPromotedObjectFilter(str) {
      const list = this.gameAppIdList.filter((item) => {
        const { promoted_object_name: name, promoted_object_id: id } = item
        return name.includes(str) || String(id).includes(str)
      })
      return list
    },
    onPromotedObjectChange() {
      this.$emit('change')
    },
    onClear() {
      this.$emit('clear')
    }
  }
}
</script>

<style lang="scss" scoped>
.promoted-object {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-avatar {
    min-width: 32px;
  }
  .app-name {
    display: inline-block;
    min-width: 260px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>

<style lang="scss">
.el-option-slot {
  display: flex;
  align-items: center;
  > span {
    line-height: 1;
  }
}
</style>
